import * as React from 'react';

export interface HighlighterProps {
  dataHook?: string;
  match?: string;
  children?: React.ReactNode;
  emphasize?: 'text' | 'background';
}

export default class Highlighter extends React.PureComponent<HighlighterProps> {}
